<template>
  <div class="card-step-banner">
    <div class="background-decoration-left">
      <div class="background-decoration-left-top">
        <svg
          width="287"
          height="132"
          viewBox="0 0 287 132"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse
            cx="68.8335"
            cy="167"
            rx="217.5"
            ry="216"
            fill="url(#paint0_radial_1841_14004)"
          />
          <defs>
            <radialGradient
              id="paint0_radial_1841_14004"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(68.8335 167) rotate(90) scale(216 217.5)"
            >
              <stop stop-color="#474EFE" stop-opacity="0.4" />
              <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
          </defs>
        </svg>
      </div>
      <div class="background-decoration-top">
        <svg
          width="395"
          height="132"
          viewBox="0 0 395 132"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse
            cx="197.5"
            cy="-3.5"
            rx="197.5"
            ry="196.5"
            fill="url(#paint0_radial_1841_14006)"
          />
          <defs>
            <radialGradient
              id="paint0_radial_1841_14006"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(197.5 -3.5) rotate(90) scale(196.5 197.5)"
            >
              <stop stop-color="#329EF9" stop-opacity="0.1" />
              <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
          </defs>
        </svg>
      </div>
    </div>
    <div class="banner-content">
      <!-- image -->
      <div class="banner-image">
        <b-img
          class="banner-image__img"
          :src="require(`@/assets/image-simple-steps-banner.svg`)"
        ></b-img>
      </div>
      <div class="banner-text">
        <p class="banner-text__title">3 simple steps to start your work</p>
        <div class="steps-list">
          <!-- step 1 -->
          <div class="step-item">
            <div class="step-item__icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM16.75 9.45703L11 15.207L7.5 11.707L8.20703 11L11 13.793L16.043 8.75L16.75 9.45703Z"
                  fill="#3C44B1"
                  stroke="url(#paint0_linear_1841_14106)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_1841_14106"
                    x1="12"
                    y1="22"
                    x2="12"
                    y2="2"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#474EFE" />
                    <stop offset="1" stop-color="#7523E1" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div class="step-item__text">Read the question and assessment rubric.</div>
          </div>

          <!-- step 2 -->
          <div class="step-item">
            <div class="step-item__icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM16.75 9.45703L11 15.207L7.5 11.707L8.20703 11L11 13.793L16.043 8.75L16.75 9.45703Z"
                  fill="#3C44B1"
                  stroke="url(#paint0_linear_1841_14106)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_1841_14106"
                    x1="12"
                    y1="22"
                    x2="12"
                    y2="2"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#474EFE" />
                    <stop offset="1" stop-color="#7523E1" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div class="step-item__text">
              <p>Drop your casual or full evidence then click</p>
              <p class="step-item__text-bold">Save changes.</p>
              <p class="m-0">(You can revise it anytime)</p>
            </div>
          </div>

          <!-- step 3 -->
          <div class="step-item">
            <div class="step-item__icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM16.75 9.45703L11 15.207L7.5 11.707L8.20703 11L11 13.793L16.043 8.75L16.75 9.45703Z"
                  fill="#3C44B1"
                  stroke="url(#paint0_linear_1841_14106)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_1841_14106"
                    x1="12"
                    y1="22"
                    x2="12"
                    y2="2"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#474EFE" />
                    <stop offset="1" stop-color="#7523E1" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div class="step-item__text">
              <p>Revise overall then click</p>
              <p class="step-item__text-bold">Preview & Submit</p>
              <p>send it for evaluation.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="background-decoration-right">
      <svg
        width="271"
        height="100"
        viewBox="0 0 271 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse cx="217.5" cy="216" rx="217.5" ry="216" fill="url(#paint0_radial_1841_14005)" />
        <defs>
          <radialGradient
            id="paint0_radial_1841_14005"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(217.5 216) rotate(90) scale(216 217.5)"
          >
            <stop stop-color="#474EFE" stop-opacity="0.4" />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </radialGradient>
        </defs>
      </svg>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.card-step-banner {
  width: 100%;
  display: flex;
  flex-direction: row;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid #eeeff8;
}

.banner-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;
  z-index: 2;
  gap: 32px;

  .banner-image {
    display: flex;

    &__img {
      width: 130px;
      height: auto;
    }
  }

  .banner-text {
    flex: 1;
  }

  .steps-list {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 20px;
  }

  .step-item {
    flex: 1;
    display: flex;
    gap: 4px;
    font-size: 14px;
    width: 100%;
    color: #7a7b97;

    &__icon {
      flex-shrink: 0;
    }

    &__text {
      display: inline;
      width: 100%;

      p {
        display: inline-block;
        margin: 0;
        white-space: nowrap;
      }

      .step-item__text-bold {
        padding: 0px 4px;
        font-weight: 700;
      }
    }
  }
}

.background-decoration-left {
  flex-direction: row;
  position: relative;

  .background-decoration-left-top {
    position: absolute;
    bottom: 0;
  }
  .background-decoration-top {
    position: absolute;
  }
}

.background-decoration-right {
  position: absolute;
  right: 0;
  bottom: 0;
}

@media screen and (min-width: 992px) {
  .banner-content {
    .steps-list {
      flex-direction: row;

      .step-item .step-item__text .step-item__text-bold {
        padding: 0;
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .banner-content {
    flex-direction: row;
  }
}
</style>
